module.exports = __webpack_public_path__ + "static/media/door-open.7af067d9.svg";